import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useSetAtom } from 'jotai';
import { openSnackbarAdviseAtom } from '../../../../../Atoms';
import CtaDialog from './CtaDialog';
import useAPI from '../../../../../api';

const EMAIL_TEXT_ALIGN = {
  center: 'center',
  'flex-end': 'right',
  end: 'right',
  right: 'right',
};

const CallToAction = function CallToAction({
  id,
  ctaId = null,
  edit = false,
  text = '',
  onChange = () => {},
  activityId = '',
  forEmail = false,
  style = {},
  buttonStyle = {},
}) {
  const intl = useIntl();
  const API = useAPI();
  const navigate = useNavigate();

  const setOpenSnackbar = useSetAtom(openSnackbarAdviseAtom);
  const [ctaDialog, setCtaDialog] = useState(null);

  const openCtaDialog = (event, elId) => {
    event.preventDefault(); //prevents href
    setCtaDialog(elId || true);
  };
  const closeCtaDialog = () => {
    setCtaDialog(null);
  };

  const handleCreateCTA = (data) => {
    if (data?.ctaId) {
      onChange({ ...data, style, buttonStyle, id, type: 'button' });
      closeCtaDialog();
      setOpenSnackbar({
        severity: 'success',
        message: intl.messages.CTA_ADDED_SUCCESSFULLY,
      });
    } else
      API.createCallToAction(
        data,
        {},
        (response) => {
          onChange({
            ...response,
            ctaId: response?.id,
            style,
            buttonStyle,
            id,
            type: 'button',
          });
          closeCtaDialog();
          setOpenSnackbar({
            severity: 'success',
            message: intl.messages.CTA_CREATED_SUCCESSFULLY,
          });
        },
        () => {
          setOpenSnackbar({
            severity: 'error',
            message: intl.messages.ERROR_IN_CTA_CREATION,
          });
        }
      );
  };

  const handleRegisterActivity = (event) => {
    event.preventDefault(); //prevent href
    if (ctaId && activityId)
      API.registerCallToActionInteraction(
        ctaId,
        activityId,
        {},
        (responseText) => {
          navigate('/responseRegistered', { state: { responseText } });
        },
        () => {
          setOpenSnackbar({
            severity: 'error',
            message: intl.messages.IMPOSSIBLE_TO_REGISTER,
          });
        }
      );
  };

  return (
    <>
      <span
        style={{
          display: 'flex',
          padding: '2%',
          ...style,
          ...(forEmail
            ? {
                display: 'block',
                textAlign:
                  style?.textAlign ||
                  EMAIL_TEXT_ALIGN[style?.justifyContent] ||
                  'left',
              }
            : {}),
        }}
      >
        {ctaId ? (
          <a
            id={id}
            role="button"
            href={forEmail && !edit ? `{CTA.${ctaId}}` : '#'}
            onClick={(e) =>
              edit ? openCtaDialog(e, ctaId) : handleRegisterActivity(e)
            }
            style={{
              display: 'inline-block',
              textDecoration: 'none',
              minWidth: '64px',
              cursor: 'pointer',
              backgroundColor: '#1D5B9D',
              color: '#fff',
              padding: '10px 20px',
              borderRadius: '50px',
              textAlign: 'center',
              ...buttonStyle,
            }}
          >
            <span
              style={{
                fontFamily: 'Roboto',
                textTransform: 'uppercase',
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: 1.75,
                letterSpacing: '0.045em',
              }}
            >
              {text}
            </span>
          </a>
        ) : (
          <Button
            id="create-cta-btn"
            sx={{
              color: 'white.main',
              bgcolor: 'greys.disableBtn',
              width: '110px',
              '&:hover': { bgcolor: 'greys.disableBtn' },
            }}
            endIcon={<EditRoundedIcon />}
            onClick={openCtaDialog}
            disableElevation
          >
            CTA
          </Button>
        )}
      </span>
      <CtaDialog
        open={ctaDialog}
        close={closeCtaDialog}
        onSubmit={handleCreateCTA}
      />
    </>
  );
};

export default CallToAction;
